module.exports = __webpack_public_path__ + "img/6.e71b8b7a.png";